import { render, staticRenderFns } from "./templateNavbar.vue?vue&type=template&id=638835ea&scoped=true"
import script from "./templateNavbar.vue?vue&type=script&lang=js"
export * from "./templateNavbar.vue?vue&type=script&lang=js"
import style0 from "./templateNavbar.vue?vue&type=style&index=0&id=638835ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638835ea",
  null
  
)

export default component.exports